export default "__VITE_ASSET__BvI1EKnq__"